export default "/images/departments.svg?30d64aac028d560fb33a27330a54fb85";